import { Box, Center } from "@chakra-ui/layout";

export const About = () => {
   return (
      <div>
         <br />
         <br />
         <br />
         <br />
         <Center>
            <Box>
               <h1>This page is under construction</h1>
            </Box>
            <br></br>
         </Center>
      </div>
   );
};
